module.exports = __webpack_public_path__ + "img/BOTSALUDO.2ca8ffed.png";